const NEW_APPLICATION = 'New Application'

export { NEW_APPLICATION }
